type LocaleNames = Record<string, string>
type ElearningProductNames = Record<string, LocaleNames>

const ELEARNING_PRODUCT_NAMES: ElearningProductNames = {
  intro_cm_elearn: {
    fr:      'Introduction à la Gestion du Changement eLearning',
    pt:      'Introdução à Gestão de Mudanças eLearning',
    ja:      'チェンジマネジメントの基礎知識',
    es:      'Introducción a la Gestión de Cambios eLearning',
  },
  leading_elearn: {
    fr:        'Introduction à la Conduite du Changement eLearning',
    de:        'Einführung in die Führung von Veränderungen',
    pt:        'Introdução à Liderança em Mudanças eLearning',
    es:        'Introducción a Liderar el Cambio eLearning',
    ja:        '変革を導くための基礎知識',
    'zh-Hans': '领导变革简介',
  },
  intro_adkar_elearn: {
    fr:        'Introduction à ADKAR eLearning',
    de:        'Einführung in ADKAR',
    pt:        'Introdução ao ADKAR eLearning',
    es:        'Introducción al Modelo ADKAR eLearning',
    ja:        'ADKARの概要',
    'zh-Hans': 'ADKAR 简介',
  },
  thrive_elearn: {
    fr:        'Réussir au Fil du Changement eLearning',
    de:        'Erfolgreich durch Change',
    pt:        'Prosperando na mudança eLearning',
    es:        'Prosperar a Través del Cambio eLearning',
    ja:        '変革を実現させるには',
    'zh-Hans': '通过变革茁壮成长',
  },
}

/**
 * Returns the localized display name for an eLearning product.
 * Falls back to the English name if the locale has no translation.
 * Returns undefined for non-eLearning products so callers can use p.name.
 */
export function getElearningProductName(
  productCode: string,
  locale: string | undefined
): string | undefined {
  const names = ELEARNING_PRODUCT_NAMES[productCode]
  if (!names || !locale) return undefined
  return names[locale]
}
